import PolicyLayout, { Section } from "../../components/public/PolicyLayout";

export default function Pricing() {
  return (
    <PolicyLayout
      title="Pricing Details"
      subtitle="How Air12 service pricing works."
      updated="May 2026"
      testid="pricing-page"
    >
      <Section heading="What Air12 pricing depends on">
        <p>Air12 service pricing is calculated from the specifics of your shipment. Key factors include:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Route (Air12 Priority Route)</li>
          <li>Chargeable weight</li>
          <li>Package dimensions</li>
          <li>Package count</li>
          <li>Invoice value</li>
          <li>Goods category</li>
          <li>Local movement requirements</li>
          <li>GST</li>
          <li>Operational feasibility</li>
        </ul>
      </Section>
      <Section heading="Indicative estimate before booking">
        <p>You may check an indicative Air12 service estimate before booking using the Check Price estimator. The estimate is
        for guidance only.</p>
      </Section>
      <Section heading="Final price confirmation">
        <p>The final Air12 service price is confirmed after shipment and document review. The confirmed price is shown once
        your shipment details have been submitted and reviewed.</p>
      </Section>
      <Section heading="Taxes">
        <p>GST applies on Air12 service charges.</p>
      </Section>
      <Section heading="Insurance">
        <p>Cargo insurance is mandatory and is separate from the Air12 service price unless expressly stated otherwise.</p>
      </Section>
      <Section heading="Questions">
        <p>For pricing questions, contact us at info@air12.in.</p>
      </Section>
    </PolicyLayout>
  );
}
